import React from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";

const Categories = ({ handleAddCat }: any) => {
  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Create New Category</h4>
          <ImCancelCircle className="catCancel" onClick={handleAddCat} />
        </div>
        <div className="line"></div>

        <div className="catModalInput">
          <input type="text" placeholder="Category Name" />
        </div>

        <div className="catModalBtn">
          <button className="catBtn1">Create</button>
          <button className="catBtn2" onClick={handleAddCat}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Categories;
